import styled from 'styled-components'

export const LoaderWrapper = styled.div`
  background-color: ${(props) => props.bgColor};
  .loader-image-container {
    position: absolute;
    background-color: ${(props) => props.bgColor || 'rgba(0,0,0,0.5)'};
    min-height: 100%;
    width: 100%;
    max-width: 768px;
    z-index: 100;
    top: 0;
    bottom: 0;
  }

  .loader-height {
    height: ${(props) => props.height || '100vh'};
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .loader-image {
    position: absolute;
    top: 50%;
    left: 40%;
    width: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (min-device-width: 450px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
    .loader-image-container {
      max-width: 100%;
    }
  }
`
